<template>
  <div class="container">
    <div
      id="success-overlay"
      class="modal modal-sm modal-success"
      v-bind:class="{ 'is-active' : isCardModalActive}"
    >
      <div class="modal-background scaleInCircle"></div>
      <div class="modal-content scaleIn">
        <div class="flex-card simple-shadow">
          <div class="card-body">
            <div class="content pb-20">
            <h2 class="has-text-centered pb-10">تنبيه</h2>
              <p>سيتم حجز موعد تحقق من بيانات KYC</p>

              <hr />
              <a class="button btn-align btn-hero is-warning raised is-large">
                <b>تاريخ {{ customerdateformatted }}</b>
              </a>
              <br />

              <a class="button btn-align btn-hero is-warning raised is-large mt-20">
                <b>بتوقيت {{ customertime }}</b>
              </a>
            </div>
            <div class="mt-20">
              <a
                class="button is-info raised btn-align is-large modal-dismiss is-bold ml-10"
                v-bind:class="{ 'is-loading' : isLoading}"
                @click="book()"
              >
                <b>تأكيد و حجز</b>
              </a>

              <a
                class="button is-dark btn-align modal-dismiss is-bold is-large"
                @click="isCardModalActive=false"
              >
                <b>عودة</b>
              </a>
            </div>
          </div>
        </div>
      </div>
      <button class="modal-close is-large" @click="isCardModalActive=false"></button>
    </div>
    <!-- Hero image -->
    <div class="hero-body">
      <div class="container has-text-centered pb-90">
        <div class="columns">
          <div class="column is-6 is-offset-3">
            <!-- Login form -->
            <div class="animated preFadeInLeft fadeInLeft pb-90">
              <router-link to="/" class="logo">
                <img class src="~/../assets/images/logos/brand-logo.png" alt />
              </router-link>
              <hr />
              <h1 class="title is-4">تحديد موعد مقابلة لتأكيد بيانات KYC</h1>

              <b-message v-if="message!=''" title="تنبيه" type="is-info">
                <b>{{ message }}</b>
              </b-message>

              <hr />

              <v-date-picker
                v-model="customerdate"
                locale="ar"
                :popover="{ placement: 'bottom', visibility: 'click' }"
                :first-day-of-week="1"
                :disabled-dates="{ weekdays: offDays }"
                :input-props="{
                      readonly: true
                      }"
                :min-date="minDate"
                :max-date="maxDate"
              >
                <b-field :expanded="true" label="تاريخ مقابلة" size="is-large" class="is-fullwidth">
                  <b-input
                    readonly
                    type="text"
                    size="is-large "
                    class="text-ccenter"
                    :value="customerdateformatted"
                    placeholder="اختر تاريخ"
                    expanded
                  ></b-input>
                </b-field>
              </v-date-picker>

              <hr />
              <div class="columns has-text-centered is-centered" v-if="slotsloading">
                <loading
                  line-fg-color="var(--primary-color)"
                  size="large"
                  class="margin-100"
                  text-fg-color="#2d3f51"
                  message="الرجاء الإنتظار"
                />
              </div>

              <div class="field-body is-loading" v-else-if="customerdateformatted!=null">
                <table class="table is-fullwidth mb-40">
                  <tbody>
                    <tr>
                      <th width="45">التوقيت</th>
                      <th width="45">الحالة</th>
                      <th width="10"></th>
                    </tr>

                    <tr v-for="slot of timeslots " :key="slot.id">
                      <td data-th="ID">{{ slot.StartTime }}</td>

                      <td data-th="Name">
                        <!-- {{ slot.reserved }} -->
                        <span
                          v-if="slot.Status == 'true'"
                          class="tag is-primary is-bold has-text-black is-medium"
                        >
                          <b>متوفر</b>
                        </span>
                        <span v-else class="tag is-danger is-bold is-medium">
                          <b>محجوز</b>
                        </span>
                      </td>
                      <td data-th="Role">
                        <a
                          class="button info-btn is-medium"
                          @click="selectTime(slot.StartTime)"
                          :class="{'is-disabled ' : slot.Status == 'false'}"
                        >
                          <b v-if="slot.Status == 'true'">حجز</b>
                          <b v-else>لايمكن حجز</b>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="container pt-90 pb-90">
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>
              <div v-if="checkIfWeekend(customerdate)">عفواً لايمكن حجز يوم جمعة او السبت</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import arabic from "vee-validate/dist/locale/ar";
import moment from "moment";
import { AtomSpinner } from "epic-spinners";
import { constants } from "crypto";
var minutesOfDay = function(m) {
  return m.minutes() + m.hours() * 60;
};

const today = new Date();
const min = new Date();
min.setHours(9);
min.setMinutes(0);
const max = new Date();
max.setHours(18);
max.setMinutes(0);
export default {
  name: "book",
  props: ["customer_id", "branch_id"],
  data() {
    return {
      code: "",
      local: "ar",
      message: "",
      messagetype: "is-info",
      slotsloading: false,
      offDays: [],
      isLoading: false,
      minTime: min,
      maxTime: max,
      date: null,
      minDate: null,
      maxDate: null,
      isLoading: false,
      isFullPage: true,
      timeslots: null,
      message: "",
      calanderloading: false,
      workCalendarId: "",
      customerdate: null,
      customertime: null,
      isCardModalActive: false
    };
  },
  methods: {
    dateformat(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    openLoading() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 10 * 1000);
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.verifiy();
          return;
        }
      });
    },
    book() {
      this.isLoading = !this.isLoading;
      var fixinfo = {
        customer_id: this.customer_id,
        branch_id: this.branch_id,
        selected_date: this.customerdateformatted,
        selected_time: this.customertime,
        reason: "kyc"
      };
      axios
        .post("customer/book", fixinfo)
        .then(response => {
          // this.$router.push("/");

          if (response.data.status === "success") {
            this.$router.push({
              name: "bookingsuccess",
              params: {
                customer_id: this.customer_id,
                customerdate: this.customerdateformatted,
                customertime: this.customertime
              }
            });
          }
          if (response.data.status === "fail") {
            this.customertime = null;
            this.gettimeslots();
            this.message = response.data.message;
            this.isCardModalActive = false;
            // this.$router.push("/");
          }
          this.isLoading = !this.isLoading;
        })
        .catch(error => {
          this.isLoading = !this.isLoading;
          this.message = error.message;
        });
    },
    gettimeslots() {
      var info = {
        work_calendar_id: this.workCalendarId,
        selected_date: moment(this.customerdate).format("YYYY-MM-DD")
      };

      this.slotsloading = true;
      console.log("req " + info);
      axios
        .post("customer/calendar/slots/", info)
        .then(response => {
          this.timeslots = response.data.Slots;

          this.timeslots.map(obj => {
            var currentTime = moment();
            var endTime = moment(obj.StartTime, "HH:mm");

            if (
              currentTime.isAfter(endTime) &&
              currentTime == moment(this.customerdate)
            ) {
              obj.Status = "false";
            }

            return obj;
          });

          this.slotsloading = false;
          console.log(response);
          // if (response.data.status === "success") {
          //       return
          // } else if (response.data.status === "fail") {

          // }
        })
        .catch(error => {
          console.log(error);
        });
      // console.log('x22xx');
    },
    selectTime(time) {
      this.customertime = time;
      // this.isCardModalActive = true;
      this.book();
    },
    checkIfWeekend(date) {
      return (
        moment(this.customerdate).day() == 6 ||
        moment(this.customerdate).day() == 5
      );
    },
    CalcOffDays(days) {
      days.saturday == false ? this.offDays.push(7) : null;
      days.friday == false ? this.offDays.push(6) : null;
      days.thursday == false ? this.offDays.push(5) : null;
      days.wednesday == false ? this.offDays.push(4) : null;
      days.tuesday == false ? this.offDays.push(3) : null;
      days.monday == false ? this.offDays.push(2) : null;
      days.sunday == false ? this.offDays.push(1) : null;

      console.log(this.offDays);
    }
  },
  watch: {
    customerdate: function() {
      if (
        this.customerdate != null &&
        this.customerdate != "" &&
        moment(this.customerdate).day() != 6 &&
        moment(this.customerdate).day() != 5
      ) {
        this.gettimeslots();
      }
    }
  },
  computed: {
    customerdateformatted: function() {
      if (this.customerdate != null)
        return moment(this.customerdate).format("YYYY-MM-DD");
      else return null;
    }
  },

  mounted() {
    moment.locale("en");

    this.calanderloading = true;
    axios
      .get("scheduler/getCurrentWC/" + this.branch_id)
      .then(response => {
        console.log(response);
        this.CalcOffDays(response.data.data);

        if (
          moment(response.data.data.start_day).toDate() <= moment().toDate()
        ) {
          this.minDate = moment().toDate();
        } else {
          this.minDate = moment(response.data.data.start_day).toDate();
        }
        this.maxDate = moment(response.data.data.end_day).toDate();
        this.workCalendarId = response.data.data.id;
        this.calanderloading = false;

        this.message =
          " الحجوزات مفتوحة من " +
          this.dateformat(moment(response.data.data.start_day).toDate()) +
          " الى " +
          this.dateformat(this.maxDate);

        console.log("22" + this.message);
      })
      .catch(error => {
        // this.$router.push('/');
      });
    this.$validator.localize("ar", {
      messages: arabic.messages,
      attributes: {
        code: "كود التفعيل"
      }
    });
  }
};
</script>
